function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Wallet({
  width = 35,
  height = 36,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M31.557 21.878h-5.904c-2.168-.002-3.925-1.75-3.926-3.908 0-2.158 1.758-3.906 3.926-3.907h5.904M26.32 17.88h-.454",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M11.299 5.332h12.605c4.226 0 7.652 3.411 7.652 7.62v10.42c0 4.208-3.426 7.62-7.652 7.62H11.299c-4.227 0-7.653-3.412-7.653-7.62v-10.42c0-4.209 3.426-7.62 7.653-7.62z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M10.26 11.92h7.874",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=Wallet.js.map